import { useCallback } from 'react';
import { performBoothStationHandoff } from '../lib/booth/perform-booth-station-handoff';
import { useBoothReset } from './useBoothReset';

export function useBoothHandoff({
  onRestartTour,
}: {
  onRestartTour: () => void;
}) {
  const resetPortalForNewRun = useBoothReset();

  return useCallback(async () => {
    await performBoothStationHandoff({
      resetPortalForNewRun,
      onRestartTour,
    });
  }, [onRestartTour, resetPortalForNewRun]);
}
